// Author thq
// Date 2022-02-17 15:57:52

class RepairSppOrder {
constructor({
        id = null,
        workOrderCode = '',
        rsoCodeSpp = '',
        rsoIdSpp = '',
        status = '',
        rsoVerifier = '',
        rsoVerifierRealName = '',
        rsoConsignor = '',
        rsoConsignorRealName = '',
        rsoAcceptor = '',
        rsoAcceptorRealName = '',
        rsoCodeRor = '',
        rsoIdRpr = '',
        rsoRepFactory = '',
        rsoRepairDate = '',
        rsoRestoreDate = '',
        rsoAttachment = '',
        rsoRemark = '',
        rsoAttachmentList = ''}
= {}) {
    this.id = id;
    this.workOrderCode = workOrderCode;
    this.rsoCodeSpp = rsoCodeSpp;
    this.rsoIdSpp = rsoIdSpp;
    this.status = status;
    this.rsoVerifier = rsoVerifier;
    this.rsoVerifierRealName = rsoVerifierRealName;
    this.rsoConsignor = rsoConsignor;
    this.rsoConsignorRealName = rsoConsignorRealName;
    this.rsoAcceptor = rsoAcceptor;
    this.rsoAcceptorRealName = rsoAcceptorRealName;
    this.rsoCodeRor = rsoCodeRor;
    this.rsoIdRpr = rsoIdRpr;
    this.rsoRepFactory = rsoRepFactory;
    this.rsoRepairDate = rsoRepairDate;
    this.rsoRestoreDate = rsoRestoreDate;
    this.rsoAttachment = rsoAttachment;
    this.rsoRemark = rsoRemark;
    this.rsoAttachmentList = rsoAttachmentList;
}
}

function newEntity() {
return new RepairSppOrder();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.repair.repairSppOrder.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.repair.repairSppOrder.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoCodeSpp',
        label: 'label.em.repair.repairSppOrder.grid.rsoCodeSpp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoNameSpp',
        label: 'label.em.repair.repairSppOrder.grid.rsoNameSpp',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoIdSpp',
        label: 'label.em.repair.repairSppOrder.grid.rsoIdSpp',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.em.repair.repairSppOrder.grid.status',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoAuthor',
        label: 'label.em.repair.repairSppOrder.grid.rsoAuthor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoVerifierRealName',
        label: 'label.em.repair.repairSppOrder.grid.rsoVerifierRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoConsignorRealName',
        label: 'label.em.repair.repairSppOrder.grid.rsoConsignorRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoAcceptorRealName',
        label: 'label.em.repair.repairSppOrder.grid.rsoAcceptorRealName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoCodeRor',
        label: 'label.em.repair.repairSppOrder.grid.rsoCodeRor',
        sortable: true,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairOrigin'
        }
        },
        {
        key: 'rsoIdRpr',
        label: 'label.em.repair.repairSppOrder.grid.rsoIdRpr',
        sortable: true,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairPriority'
        }
        },
        {
        key: 'rsoRepFactory',
        label: 'label.em.repair.repairSppOrder.grid.rsoRepFactory',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoRepairDate',
        label: 'label.em.repair.repairSppOrder.grid.rsoRepairDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoRestoreDate',
        label: 'label.em.repair.repairSppOrder.grid.rsoRestoreDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoAttachmentList',
        label: 'label.em.repair.repairSppOrder.grid.rsoAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'rsoRemark',
        label: 'label.em.repair.repairSppOrder.grid.rsoRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.repair.repairSppOrder.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    workOrderCodeFilter : '',
    rsoCodeSppFilter : '',
    rsoIdSppFilter : '',
    statusFilter : '',
    rsoAuthorFilter : '',
    rsoAuthorRealNameFilter : '',
    rsoVerifierFilter : '',
    rsoVerifierRealNameFilter : '',
    rsoConsignorFilter : '',
    rsoConsignorRealNameFilter : '',
    rsoAcceptorFilter : '',
    rsoAcceptorRealNameFilter : '',
    rsoCodeRorFilter : '',
    rsoIdRprFilter : '',
    rsoRepFactoryFilter : '',
    rsoRepairDateRteFilter : '',
    rsoRepairDateLteFilter : '',
    rsoRestoreDateRteFilter : '',
    rsoRestoreDateLteFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.repair.repairSppOrder.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoCodeSppFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoCodeSpp',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSppSparePartsSpa'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.repair.repairSppOrder.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'RepairSppOrder',statusFilter:1}
        }
        },
        {
        key: 'rsoAuthorFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoAuthor',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoAuthorRealNameFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoAuthorRealName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoAuthor":"loginName"}'
                }
        },
        {
        key: 'rsoVerifierRealNameFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoVerifierRealName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoVerifier":"loginName"}'
                }
        },
        {
        key: 'rsoConsignorRealNameFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoConsignorRealName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoConsignor":"loginName"}'
                }
        },
        {
        key: 'rsoAcceptorRealNameFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoAcceptorRealName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoAcceptor":"loginName"}'
                }
        },
        {
        key: 'rsoCodeRorFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoCodeRor',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairOrigin'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'rsoIdRprFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoIdRpr',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairPriority'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'rsoRepFactoryFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoRepFactory',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRepairDateRteFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoRepairDateRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRepairDateLteFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoRepairDateLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRestoreDateRteFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoRestoreDateRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRestoreDateLteFilter',
        label: 'label.em.repair.repairSppOrder.filter.rsoRestoreDateLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'rsoCodeSpp',
        label: 'label.em.repair.repairSppOrder.entity.rsoCodeSpp',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emSppSparePartsSpa'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"rsoIdSpp":"id"}'
                }
        },
        {
        key: 'rsoVerifierRealName',
        label: 'label.em.repair.repairSppOrder.entity.rsoVerifierRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoVerifier":"loginName"}'
                }
        },
        {
        key: 'rsoConsignorRealName',
        label: 'label.em.repair.repairSppOrder.entity.rsoConsignorRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoConsignor":"loginName"}'
                }
        },
        {
        key: 'rsoAcceptorRealName',
        label: 'label.em.repair.repairSppOrder.entity.rsoAcceptorRealName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"rsoAcceptor":"loginName"}'
                }
        },
        {
        key: 'rsoCodeRor',
        label: 'label.em.repair.repairSppOrder.entity.rsoCodeRor',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairOrigin'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'rsoIdRpr',
        label: 'label.em.repair.repairSppOrder.entity.rsoIdRpr',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'repairPriority'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'rsoRepFactory',
        label: 'label.em.repair.repairSppOrder.entity.rsoRepFactory',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRepairDate',
        label: 'label.em.repair.repairSppOrder.entity.rsoRepairDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoRemark',
        label: 'label.em.repair.repairSppOrder.entity.rsoRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'rsoAttachmentList',
        label: 'label.em.repair.repairSppOrder.entity.rsoAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'rsoAttachment'
                }
        }
]

export {RepairSppOrder, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
